const cityNeighborhoods = {
  // ZIPs per the Figma design (node 414:404). The last eleven are nearby towns
  // rather than Jackson neighbourhoods, which is why they carry their own ZIPs.
  jackson: [
    { name: "Downtown Jackson", zips: "49201, 49203" },
    { name: "West Avenue", zips: "49201, 49203" },
    { name: "East Side", zips: "49201" },
    { name: "South Side", zips: "49202" },
    { name: "North Side", zips: "49203" },
    { name: "Parnall", zips: "49201" },
    { name: "Wildwood Park", zips: "49202" },
    { name: "Fourth Street", zips: "49202" },
    { name: "Ganson", zips: "49201" },
    { name: "Airport Road", zips: "49201, 49203" },
    { name: "Spring Arbor Road", zips: "49201" },
    { name: "Blackman Township", zips: "49201, 49203" },
    { name: "Summit Township", zips: "49201, 49203, 49246" },
    { name: "Vandercook Lake", zips: "49203" },
    { name: "Brooklyn", zips: "49230" },
    { name: "Michigan Center", zips: "49254" },
    { name: "Spring Arbor", zips: "49283" },
    { name: "Napoleon", zips: "49261" },
    { name: "Parma", zips: "49269" },
    { name: "Grass Lake", zips: "49240" },
    { name: "Clarklake", zips: "49234" },
    { name: "Pleasant Lake", zips: "49272" },
    { name: "Rives Junction", zips: "49277" },
    { name: "Horton", zips: "49246" },
    { name: "Concord", zips: "49237" },
  ],
  // Entries may be a plain name or { name, zips }. Wyoming carries ZIPs per the
  // Figma design (node 428:394); cities left as plain strings render unchanged.
  // The last six are nearby cities rather than Wyoming neighbourhoods, which is
  // why they carry their own ZIPs.
  wyoming: [
    { name: "Downtown Wyoming", zips: "49509" },
    { name: "28th Street Corridor", zips: "49509" },
    { name: "Buchanan", zips: "49509" },
    { name: "Galewood", zips: "49509" },
    { name: "Godfrey-Lee", zips: "49509" },
    { name: "Gezon Parkway", zips: "49509" },
    { name: "Lemmen-Holton", zips: "49509" },
    { name: "Roosevelt Park", zips: "49509" },
    { name: "Westgate", zips: "49509" },
    { name: "Sunset Hills", zips: "49509" },
    { name: "Kelloggsville", zips: "49509" },
    { name: "Marquette", zips: "49509" },
    { name: "Wyoming Park", zips: "49509" },
    { name: "Panhandle", zips: "49509" },
    { name: "Grandville", zips: "49418" },
    { name: "Byron Center", zips: "49315" },
    { name: "Kentwood", zips: "49508, 49512, 49548" },
    { name: "Grand Rapids", zips: "49503, 49507" },
    { name: "Hudsonville", zips: "49426" },
    { name: "Cutlerville", zips: "49315, 49508, 49509, 49548" },
  ],
};

module.exports = cityNeighborhoods;
